import React, { useEffect, useState } from 'react'
import { Card, Grid,  Stack, TextField, DialogTitle, IconButton } from '@mui/material'
import MDButton from 'components/MDButton'
import {  openSnackbar } from '../../redux/slices/common';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { isValidNumber } from 'utilities/common';
import { addPromoData, editPromoData } from '../../redux/slices/metrc';

export default function AddMetrcTaxData({ closeModal }) {
    const dispatch = useDispatch()
    const { loading: isBtnLoading = false } = useSelector(state => state?.metrc)
    const [errors, setErrors] = useState({})
    const { modalData } = useSelector(state => state.modal);
    const { type, title, data, edit, metrcHandler = () => { } } = modalData || {};

    const [formData, setFormData] = useState({
        taxName: '',
        taxPercentage: ''
    })

    const validateReasons = () => {
        let isError = false
        let errors = {}
        if (!formData?.taxName) {
            isError = true
            errors = { ...errors, taxName: 'Tax Name is required' }
        }
        if (!formData?.taxPercentage) {
            isError = true
            errors = { ...errors, taxPercentage: 'Tax Percentage is required' }
        }
        return { errors, isError }
    }

    const submitHandler = () => {
        const { isError, errors } = validateReasons()
        setErrors(errors)
        if (isError) return;
        setErrors({})
        const payload = {
            taxName: formData?.taxName,
            taxPercentage: Number(formData?.taxPercentage)
        }

        if (edit) {
            const id = data?.taxSettingUniqueId
            dispatch(editPromoData({ data: payload, id, type }))
                .unwrap()
                .then(res => {
                    closeModal()
                    metrcHandler();
                    showResponseMessage(res?.message, 'success');
                })
                .catch(err => {
                    showResponseMessage(err?.message, 'error');
                });
        } else {

            dispatch(addPromoData({ data: payload, type }))
                .unwrap()
                .then(res => {
                    closeModal()
                    // dispatch(getPromotionList())
                    metrcHandler();
                    showResponseMessage(res?.message, 'success');
                })
                .catch(err => {
                    showResponseMessage(err?.message, 'error');
                });
        }
    }

    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
        }
    }

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            taxName: data?.taxName || '',
            taxPercentage: data?.taxPercentage || ''
        }))


    }, [data])

    return (
        <Card sx={{ py: 3, px: 4, borderRadius: 0 }}>
            <DialogTitle id='draggable-dialog-title' sx={{ p: 0, mb: 4, px: 0 }} display='flex' alignItems='center' justifyContent='space-between' style={{ paddingLeft: '0', paddingRight: '0' }}>
                {title} Discount
                <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </DialogTitle>

            <Grid container alignItems='center' spacing={{ xs: 3, md: 3 }} mb={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <TextField
                        className="form-input currency-field"
                        fullWidth
                        label={'Tax Name'}
                        name="taxName"
                        value={formData?.taxName || ''}
                        error={Boolean(errors?.taxName)}
                        helperText={errors?.taxName}
                        onChange={(e) => {
                            setFormData({ ...formData, taxName: e.target.value });
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <TextField
                        InputProps={{
                            endAdornment: formData?.taxPercentage ? '%' : "",
                        }}
                        className="form-input currency-field"
                        fullWidth
                        label={'Tax Percentage'}
                        name="taxPercentage"
                        value={formData?.taxPercentage || ''}
                        error={Boolean(errors?.taxPercentage)}
                        onChange={(e) => {
                            if (e.target.value && !isValidNumber(e.target.value)) return;
                            setFormData({ ...formData, taxPercentage: e.target.value });
                        }}
                        helperText={errors?.taxPercentage}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={1}>
                        <MDButton sx={{ minWidth: '160px' }} type='button' variant='contained' color='primary' onClick={() => submitHandler()} disabled={isBtnLoading} loading={isBtnLoading}>
                            {edit ? 'Update ' : 'Save'}
                        </MDButton>
                        <MDButton sx={{ minWidth: '160px' }} type='button' variant='outlined' color='dark' className='dark-outlined-btn' onClick={() => closeModal()}>
                            Cancel
                        </MDButton>
                    </Stack>
                </Grid>
            </Grid>
        </Card>
    )
}